import axios from "axios";
import React, { useEffect, useState } from "react";
import LiveFanImage from "../../../assets/Icon/live.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AdminFanGroupLive = () => {
  const [event_data, setFanLiveGroup] = useState([]);
  const [fanPendingCount, setFanPendingCount] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/fan/group/adminlist/status`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setFanPendingCount(res.data.fanLiveCount);
        setFanLiveGroup(res.data.fanLiveGroup);
      }
    });
  }, []);
  return (
    <>
      <AllDataHeader
        title="Live Fan Group"
        image={LiveFanImage}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/pending-fan-group-Edit-delete`}
          fan={"true"}
        />
      )}
    </>
  );
};

export default AdminFanGroupLive;
